<template>
    <div v-if="this.employees.data" class="employee-list-datatable">

        <ul>
            <li v-for="employee in employees.data">
                <a :href="'../onboarding?profile='+employee.id+'&timeline='+employee.timeline_state">{{ employee.fullname }}</a>
            </li>
        </ul>

    </div>
</template>

<script>
    import * as actions from "../../../../../Config/ApiUrl";


    export default {
        name: "employeeListDatatable",
        props: {
           employees: [Array, Object]
        },
        data() {
            return {
                preloader: false,
            }
        }
    }
</script>
